"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = exports.mainTabSubPaths = void 0;
// --- Constants
var routePrefix = '/app';
exports.mainTabSubPaths = {
    models: 'models',
    apps: 'apps',
    workbench: 'workbench',
    collab: 'collab',
    orchestration: 'orchestration',
    data: 'data',
};
// --- Derived paths
var mainTabs = {
    models: routePrefix + '/' + exports.mainTabSubPaths.models,
    apps: routePrefix + '/' + exports.mainTabSubPaths.apps,
    workbench: routePrefix + '/' + exports.mainTabSubPaths.workbench,
    collab: routePrefix + '/' + exports.mainTabSubPaths.collab,
    orchestration: routePrefix + '/' + exports.mainTabSubPaths.orchestration,
    data: routePrefix + '/' + exports.mainTabSubPaths.data,
};
// --- Export object
exports.routes = {
    mainTabs: mainTabs,
    noMainTabs: routePrefix + '/noPermissions',
};
//# sourceMappingURL=frontendRoutes.js.map